module.exports = __webpack_public_path__ + "img/Everywhere-2020 Infinite Recharge.5ad5d212.png";